var React = require('react');

function HomeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40 14.186V4H34V8.186L40 14.186ZM48 26L24 2L0 26H6V46H42V26H48ZM38 42H10V21.48L24 7.656L38 21.636V42ZM28 40H20V28H28V40Z","fill":"currentColor"}));
}

HomeInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none","role":"img","focusable":"false"};

module.exports = HomeInline;

HomeInline.default = HomeInline;
